import { useFontSize } from '@app/hooks';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { GraphDataPoint } from './types';
import { useTranslation } from 'react-i18next';

const MSADataChart = ({ data }: { data: GraphDataPoint[]; }) => {
  const fontSize = useFontSize();
  const { t } = useTranslation();
  const formatData = data.map(item => ({
    category: item.shortCategory ?? item.category,
    withProject: item.withProject,
    withoutProject: item.withoutProject
  }));

  // Check if we have any data for each series
  const hasProjectData = data.some(item => item.withProject !== null && item.withProject !== undefined);
  const hasBaselineData = data.some(item => item.withoutProject !== null && item.withoutProject !== undefined);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={formatData} barCategoryGap={16} barGap={4}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="category"
          fontSize={fontSize}
          interval={0}
          height={50}
        />
        <YAxis
          domain={[0, 1]}
          tickCount={6}
          tickFormatter={(value: number) => value.toFixed(1)}
        />
        <Tooltip />
        <Legend verticalAlign="top" align="center" layout="vertical" wrapperStyle={{ right: 0 }} />
        {hasBaselineData && (
          <Bar name={t('map.baseline')} dataKey="withoutProject" fill="var(--msa-baseline-border)" />
        )}
        {hasProjectData && (
          <Bar name={t('map.with_project')} dataKey="withProject" fill="var(--msa-project-border)" />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MSADataChart;